export default "__VITE_ASSET__Dkc1yqNt__"